//
//
//
//
//
//
//
//
//
//
//
//
//
//
import panel from "./panel";
import _data from "./xieyi.json";
export default {
  components: {
    panel: panel
  },
  data: function data() {
    return {
      yinsi: _data.content
    };
  }
};